import { plural } from '@cian/utils';
import { IApplicationState } from '../../types/redux';

export const selectGalleryFactoids = (state: IApplicationState): string => {
  const { area, floorCount } = state.projectData.project;

  const areaFactoid = area && `${area} м²`;
  const floorCountFactoid = floorCount && `${floorCount} ${plural(floorCount, ['этаж', 'этажа', 'этажей'])}`;

  return [areaFactoid, floorCountFactoid].filter(Boolean).join(', ');
};
